<script setup lang="ts">
import type { ListboxGroupProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { ListboxGroup, ListboxGroupLabel } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<
  ListboxGroupProps & {
    class?: HTMLAttributes['class']
    heading?: string
  }
>()

const delegatedProps = reactiveOmit(props, 'class', 'heading')
</script>

<template>
  <ListboxGroup
    v-bind="delegatedProps"
    :class="cn('overflow-hidden px-2 py-2 text-foreground border-b border-gray-100 last:border-b-0', props.class)"
  >
    <ListboxGroupLabel v-if="heading" class="px-3 py-2 text-xs font-bold text-foreground">
      {{ heading }}
    </ListboxGroupLabel>
    <slot />
  </ListboxGroup>
</template>
